module.exports = __webpack_public_path__ + "static/media/sad-cry.11f56a84.svg";